<template>
  <div class="error-container">
    <div class="error-content">
      <svg class="h-6 w-6 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <div class="error-message">
        <h3 class="text-lg font-medium text-red-800">Error loading dashboard</h3>
        <p class="mt-1 text-sm text-red-600">{{ error || 'Something went wrong. Please try again.' }}</p>
      </div>
      <button @click="$emit('retry')" class="retry-btn">
        Retry
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['retry']
}
</script>

<style scoped>
.error-container {
  @apply flex items-center justify-center;
  min-height: 26rem;
}

.error-content {
  @apply flex items-center gap-4 bg-red-50 p-4 rounded-lg;
  max-width: 32rem;
}

.error-message {
  @apply flex-1;
}

.retry-btn {
  @apply px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 
         text-sm font-medium transition-colors duration-200;
}

@media (prefers-color-scheme: dark) {
  .error-content {
    @apply bg-red-900 bg-opacity-20;
  }
  
  .error-message h3 {
    @apply text-red-300;
  }
  
  .error-message p {
    @apply text-red-400;
  }
}
</style> 